//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AppMobileNav',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showLogin: false
    }
  },

  computed: {
    ...mapGetters('user', [
      'isUser',
      'isSubscriber',
      'isCanceled',
      'isPending'
    ]),
    ...mapGetters('cart', ['bagCount'])
  },

  watch: {
    $route() {
      if (this.show) {
        this.$emit('close')
      }
    }
  }
}
